import React from 'react';
import HomeWidgetDashboard from './meeting-management/action-home-widget/HomeWidgetDashboard';

export default function Home() {
    return (
        <>
            <HomeWidgetDashboard/>
        </>
    );
}